import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { ProjectId, TaskId, TaskIdV2 } from 'api/models';
import { TaskAPI } from 'api/tasks';
import { useHash } from 'hooks/use-hash';
import { getTaskDetailQueryKey } from 'queries/task';
import { TaskDrawerParams, transformer } from './transformer';

type ShowFunction = (project: ProjectId, task: TaskIdV2) => void;
type HideFunction = () => void;

export const useTaskDrawer = (): [
  TaskDrawerParams,
  ShowFunction,
  HideFunction,
] => {
  const [params, setParams] = useHash(transformer);
  const queryClient = useQueryClient();
  const show = useCallback(
    (project: ProjectId, task: TaskIdV2) => {
      setParams(['show', project, task]);
      queryClient.prefetchQuery({
        queryKey: getTaskDetailQueryKey(TaskId(project[1], task[1])),
        queryFn: () => TaskAPI.getTask(project[1], task[1]),
      });
    },
    [queryClient, setParams],
  );
  const hide = useCallback(() => {
    setParams(['invalid']);
  }, [setParams]);

  return [params, show, hide];
};
